import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import SideMenu from "./SideMenu";

interface ISideMenuWrapperProps {
    showSideMenu: boolean;
    closeSideMenuHandler: () => void;
}

const SideMenuWrapper: React.FC<ISideMenuWrapperProps> = props => {
    const closeModalHandler = () => {
        props.closeSideMenuHandler();
    };

    return (
        <Modal className="sideMenuWrapper-modal" show={props.showSideMenu} onHide={closeModalHandler} animation={true}>
            <ModalBody className="sideMenuWrapper-modal-body">
                <SideMenu closeSideMenuHandler={closeModalHandler} />
            </ModalBody>
        </Modal>
    );
};

export default SideMenuWrapper;
